<template>
<v-autocomplete ref="focus" v-model="internalValue" :loading="loading" :items="items" item-text="title" item-value="_id" label="بانک" :rules="required ? requiredRules : []" no-data-text="اطلاعاتی موجود نیست..." clearable @change="handleChange" />
</template>

<script>
import myAxios from '../functions/myAxios'

export default {
  name: 'MyBanks',

  props: {
    value: {
      required: true,
    },

    required: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      loading: false,
      items: [],
      internalValue: this.value,

      requiredRules: [
        v => !!v || 'فیلد الزامی',
      ],
    }
  },

  watch: {
    value(newVal) {
      this.internalValue = newVal
    },
  },

  methods: {
    handleChange(value) {
      this.$emit('input', value)

      const selected = this.items.find(
        item => String(item._id) === String(value)
      )

      this.$emit('selected', selected || null)
    },

    async retrieveData() {
      this.loading = true

      try {
        const res = await myAxios({
          method: 'GET',
          url: '/api/banks',
        })

        if (res && res.data && Array.isArray(res.data.data)) {
          this.items = res.data.data.map(item => ({
            _id: item._id,
            title: `${item.id}-${item.title}`,
          }))
        }
      } catch (e) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(e)
        }
      } finally {
        this.loading = false
      }
    },
  },

  async created() {
    await this.retrieveData()
  },
}
</script>
